import { PLATFORM_ENVIRONMENT, PlatformEnvironmentName } from '@platform-frontend/platform';

export interface Environment {
  matomoSiteID: string;
  umlLabUrl: string;
}

const UML_LAB_URL: (domainEnding: string) => string = (domainEnding: string) => 'https://uml-lab' + domainEnding;
const UML_LAB_VERCEL_DOMAIN_ENDING: (environmentName: PlatformEnvironmentName) => string = (environmentName: PlatformEnvironmentName) =>
  '-' + environmentName.toLowerCase() + '.vercel.app';

export const ENVIRONMENT: Environment = {
  matomoSiteID: PLATFORM_ENVIRONMENT.isProduction ? '11' : '9',
  umlLabUrl: PLATFORM_ENVIRONMENT.isProduction
    ? UML_LAB_URL('.com')
    : PLATFORM_ENVIRONMENT.isDevelopment
    ? UML_LAB_URL('.local')
    : UML_LAB_URL(UML_LAB_VERCEL_DOMAIN_ENDING(PLATFORM_ENVIRONMENT.name))
};
